import { useEffect } from 'react';

import { translate } from '~l10n/client';

import { toast } from '~shared/components/Toast';
import { useQuizzesFolder } from '~teacher/components/quizzes/QuizPanel/hooks/useQuizzesFolder';

export function useNotifyCurrentFolderDeleted(
  currentFolder: ReturnType<typeof useQuizzesFolder>,
  parentId: number,
  setParentId: (newParentId: number) => void
) {
  useEffect(() => {
    if (
      currentFolder.isSuccess &&
      currentFolder.data &&
      parentId &&
      currentFolder.data.deleted
    ) {
      toast.critical(translate('Deleted'));
      setParentId(null);
    }
  }, [currentFolder.data, currentFolder.isSuccess, parentId, setParentId]);
}
